import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Grid,
  Paper,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
  Button,
} from "@mui/material";

import { iepaProd } from "../../constants/global";

const Process = () => {
  const [programs, setPrograms] = useState([]);
  const [adapters, setAdapters] = useState([]);
  const [subPrograms, setSubPrograms] = useState([]);

  const [program, setProgram] = useState("");
  const [adapter, setAdapter] = useState("");
  const [subProgram, setSubProgram] = useState("");

  const [programLoading, setProgramLoading] = useState(false);
  const [adapterLoading, setAdapterLoading] = useState(false);
  const [subProgramLoading, setSubProgramLoading] = useState(false);

  // ---------------- FETCH PROGRAMS ----------------
  useEffect(() => {
    const fetchPrograms = async () => {
      setProgramLoading(true);
      try {
        const res = await fetch(
        //   `${iepaProd.iepaAdapterSrvAPI}/programs/active`
        );
        const data = await res.json();
        setPrograms(data);
      } catch (err) {
        console.error("Failed to fetch programs", err);
      } finally {
        setProgramLoading(false);
      }
    };

    fetchPrograms();
  }, []);

  // ---------------- FETCH ADAPTERS ----------------
  useEffect(() => {
    if (!program) {
      setAdapters([]);
      setAdapter("");
      setSubProgram("");
      return;
    }

    const fetchAdapters = async () => {
      setAdapterLoading(true);
      try {
        const res = await fetch(
        //   `${iepaProd.iepaAdapterSrvAPI}/adapters/program`
        );
        const data = await res.json();
        setAdapters(data);
      } catch (err) {
        console.error("Failed to fetch adapters", err);
      } finally {
        setAdapterLoading(false);
      }
    };

    fetchAdapters();
  }, [program]);

  // ---------------- FETCH SUB PROGRAMS ----------------
  useEffect(() => {
    if (!adapter) {
      setSubPrograms([]);
      setSubProgram("");
      return;
    }

    const fetchSubPrograms = async () => {
      setSubProgramLoading(true);
      try {
        const res = await fetch(
        //   `${iepaProd.iepaAdapterSrvAPI}/subprograms/adapter/`
        );
        const data = await res.json();
        setSubPrograms(data);
      } catch (err) {
        console.error("Failed to fetch sub-programs", err);
      } finally {
        setSubProgramLoading(false);
      }
    };

    fetchSubPrograms();
  }, [adapter]);


  const handleSave = () => {
  console.log({ program, adapter, subProgram });
};

const handleCancel = () => {
  setProgram("");
  setAdapter("");
  setSubProgram("");
  setAdapters([]);
  setSubPrograms([]);
};
  
  // ---------------- UI ----------------
  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h3" textAlign="left" mb={3}>
        Process
      </Typography>

      <Paper sx={{ p: 4, backgroundColor: "white" }} elevation={3}>
        <Grid container spacing={2}>
          {/* PROGRAM */}
          <Grid item xs={12} sm={4}>
            <FormControl fullWidth>
              <InputLabel>Program</InputLabel>
              <Select
                value={program}
                label="Program"
                onChange={(e) => setProgram(e.target.value)}
              >
                {programLoading && (
                  <MenuItem disabled>
                    <CircularProgress size={20} />
                  </MenuItem>
                )}

                {programs.map((p) => (
                  <MenuItem key={p.id} value={p.name}>
                    {p.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          {/* ADAPTER */}
          <Grid item xs={12} sm={4}>
            <FormControl fullWidth>
              <InputLabel>Adapter</InputLabel>
              <Select
                value={adapter}
                label="Adapter"
                onChange={(e) => setAdapter(e.target.value)}
              >
                {adapterLoading && (
                  <MenuItem disabled>
                    <CircularProgress size={20} />
                  </MenuItem>
                )}

                {adapters.map((a) => (
                  <MenuItem key={a.id} value={a.name}>
                    {a.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          {/* SUB PROGRAM */}
          <Grid item xs={12} sm={4}>
            <FormControl fullWidth >
              <InputLabel>Sub-Program</InputLabel>
              <Select
                value={subProgram}
                label="Sub-Program"
                onChange={(e) => setSubProgram(e.target.value)}
              >
                {subProgramLoading && (
                  <MenuItem disabled>
                    <CircularProgress size={20} />
                  </MenuItem>
                )}

                {subPrograms.map((sp) => (
                  <MenuItem key={sp.id} value={sp.name}>
                    {sp.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
<Box mt={4} display="flex" justifyContent="flex-start" gap={2}>
  <Button
    variant="contained"
    color="primary"
    onClick={handleSave}
    disabled={!program || !adapter || !subProgram}
  >
    Save
  </Button>

  <Button
    variant="outlined"
    onClick={handleCancel}
    sx={{
      backgroundColor: "white",
      color: "black",
      borderColor: "black",
      "&:hover": {
        backgroundColor: "#f5f5f5",
        borderColor: "black",
      },
    }}
  >
    Cancel
  </Button>
</Box>
        
      </Paper>
    </Box>
  );
};

export default Process;
